
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12357',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12357",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.469",
  "data-fetching-client": "static-1.9696",
  "foundations-components": "static-1.7991",
  "foundations-components-legacy": "static-1.1016",
  "foundations-theming": "static-1.4449",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8043",
  "hub-http-shared-msw-handlers": "static-1.10032",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11501",
  "I18n": "static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "static-1.6493",
  "marketplace-storefront-base": "static-1.12418",
  "quartz": "static-1.7067",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16701",
  "reactive-variable-buffer-atom": "static-1.2888",
  "reporting-testing-lib": "static-1.9608",
  "settings-ui-lib": "static-1.12549",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7190",
  "ui-addon-i18n": "static-1.11178",
  "ui-addon-react-router-dom": "static-1.9571",
  "unified-auth": "static-1.526",
  "unified-auth-core-lib": "static-1.808",
  "usage-tracker": "static-1.7377",
  "usage-tracker-core": "static-1.7227",
  "customer-data-property-utils": "static-1.8120",
  "hub-http": "static-1.6251",
  "integrations-lib": "static-1.16249",
  "marketplace-ui-common": "static-1.19841",
  "property-management-iframe": "static-1.13254",
  "quartz-config": "static-1.845",
  "quartz-core": "static-1.6286",
  "quartz-routing": "static-1.497",
  "quick-fetch": "static-1.3939",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4681",
  "ts-schema": "static-1.4103",
  "ui-universal-auth": "static-1.9012",
  "UIComponents": "static-3.8447",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3421",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3344",
  "quartz-webpack": "static-1.3291",
  "bend-plugin-quartz-routing": "static-1.145",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4260",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4897",
  "foundations-theming-specialty": "static-1.2165",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9453",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5367",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.2030",
  "ui-fonts": "static-1.763",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-theming": "static-1.2932",
  "foundations-theming-base": "static-1.3434",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3154",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4356",
  "ai-components-ui-library": "static-1.9042",
  "ai-rendering-library": "static-1.10267",
  "chirp-fetch": "static-1.1917",
  "connections-embed-lib": "static-1.1040",
  "copilot-toolkit": "static-1.11206",
  "feedback-loader": "static-1.29348",
  "laboratory-lib": "static-3.7185",
  "marketplace-embed": "static-1.22167",
  "marketplace-ui-details": "static-1.9736",
  "marketplace-ui-reviews": "static-1.19796",
  "marketplace-ui-tracking": "static-1.14011",
  "sanitize-text": "static-1.8172",
  "ui-addon-video-player": "static-1.8732",
  "usage-tracker-multi": "static-1.5791",
  "usage-tracker-session-replay": "static-1.5063",
  "wootric-nps": "static-1.7003",
  "quartz-head": "static-1.732",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4681",
  "immer": "static-1.33",
  "immerable": "static-1.4183",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2504",
  "reporting-data": "static-1.67675",
  "cssUtils": "static-1.798",
  "flux-actions": "static-1.341",
  "HubStyle": "static-2.11808",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10237",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10395",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7367",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18373",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4544",
  "foundations-components-test-utils": "static-1.5474",
  "quartz-i18n": "static-1.742",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.322",
  "microsoft-drive-integration-lib": "static-1.446",
  "slack-ui-library": "static-1.10421",
  "fsm": "static-1.3761",
  "customer-data-objects": "static-1.7702",
  "property-translator": "static-1.5428",
  "hs-locale-management": "static-1.103",
  "frontend-preferences-client": "static-1.7956",
  "hs-promise-utils": "static-1.5620",
  "hubspot-apollo-client": "static-1.4908",
  "integrations-error-boundary-lib": "static-1.13664",
  "integrations-tracking-lib": "static-1.5631",
  "native-integrations-shared-strings": "static-1.7811",
  "reselect": "static-2.16",
  "sanitize": "static-1.4505",
  "superstore": "static-1.4790",
  "ui-shepherd-react": "static-3.10200",
  "ai-settings-ui-library": "static-1.7929",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4674",
  "immutable-less": "static-1.4682",
  "marketplace-ui-client-types": "static-1.17248",
  "nav-meta": "static-1.29750",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10277",
  "ui-addon-upgrades": "static-9.18039",
  "inbound-db-properties-service-client": "static-1.3869",
  "property-management-common": "static-1.5542",
  "ui-addon-iframeable": "static-1.9090",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.742",
  "quartz-test": "static-1.742",
  "quartz-tracking": "static-1.446",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.91",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21415",
  "ContentUtils": "static-1.68449",
  "customer-data-objects-ui-components": "static-1.13058",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.81",
  "avatar-components": "static-1.2527",
  "customer-data-filters-ui": "static-1.39900",
  "customer-data-reference-ui-components": "static-1.13195",
  "embedded-academy-lib": "static-1.14439",
  "ExportDialog": "static-6.10413",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41385",
  "reporting-snowflake": "static-1.56293",
  "reporting-ui-components": "static-2.64946",
  "reporting-visualizations": "static-1.59751",
  "ui-addon-teams": "static-1.21596",
  "magpie-lib": "static-1.5571",
  "navigation-components": "static-1.18113",
  "magpie-types": "static-1.5031",
  "simple-logging-lib": "static-1.3080",
  "ai-studio-lib": "static-1.11700",
  "app-governance-lib": "static-1.1624",
  "developer-experience-shared-components": "static-1.10540",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8029",
  "ui-product-approvals": "static-1.28223",
  "ui-tool-access": "static-1.10176",
  "usage-based-billing-components-lib": "static-1.9043",
  "usage-tracker-anonymous": "static-1.5794",
  "usage-tracker-public": "static-1.7188",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3609",
  "persist-promise": "static-1.3728",
  "reference-resolvers": "static-1.8200",
  "ui-extensibility-client-types": "static-1.3953",
  "hubspot-apollo-cache": "static-1.367",
  "universal-page-editor-lib": "static-1.3042",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2861",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5102",
  "purchase-motions-components": "static-1.5970",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1571",
  "crm-component-utils": "static-1.39154",
  "crm-properties-common-lib": "static-1.5914",
  "customer-data-properties": "static-1.51668",
  "framework-data-schema-resolvers": "static-1.6914",
  "property-value-citations": "static-1.2282",
  "reference-resolvers-lite": "static-1.8124",
  "ui-business-units-lib": "static-1.9085",
  "navigation-messaging": "static-1.7440",
  "hubspotter-http-shared-msw-handlers": "static-1.10030",
  "cms-field-types": "static-1.4841",
  "content-icons-ui": "static-1.2233",
  "customer-data-ui-utilities": "static-1.9855",
  "events-data-lib": "static-1.254",
  "conversations-skeleton-state": "static-1.7277",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22335",
  "FormUrlGenerator": "static-2.4748",
  "framework-builder-read-service-client": "static-1.4028",
  "framework-data-schema-quick-fetch": "static-1.6819",
  "multi-account-reference-resolvers": "static-1.1009",
  "onboarding-tours": "static-1.16667",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13764",
  "academy-common-lib": "static-1.13899",
  "content-assistance-lib": "static-1.7795",
  "dashboard-lib": "static-1.81644",
  "file-manager-components": "static-1.23700",
  "getting-started-shared-tasks": "static-1.18528",
  "hubspot-prosemirror": "static-1.18311",
  "hubspot-prosemirror-plugins": "static-1.18303",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19881",
  "share-with-third-party-component-lib": "static-1.8731",
  "ui-addon-draggable": "static-3.4792",
  "ui-asset-management-lib": "static-1.11075",
  "user-context": "static-1.5134",
  "growth-payments-core": "static-1.25460",
  "reporting-plugins": "static-1.10371",
  "reporting-reports": "static-1.67353",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.752",
  "nest": "static-1.259",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10655",
  "framework-listing-lib": "static-2.28788",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30783",
  "apps-service-types": "static-1.3909",
  "oauth-service-types": "static-1.4280",
  "ui-product-approvals-common": "static-1.118",
  "onboarding-scopes": "static-1.6490",
  "onboarding-tours-client": "static-1.4881",
  "platform-infra-nav-components": "static-1.7694",
  "subscription-experience-data-types": "static-1.14973",
  "crm-record-cards-service-types": "static-1.3615",
  "location-customization-utils-lib": "static-1.9345",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5973",
  "signup-constants": "static-1.18897",
  "signup-ui-url-generator": "static-2.8081",
  "card-properties-lib": "static-1.44275",
  "commerce-subscription-lib": "static-1.37202",
  "crm-actions": "static-1.6356",
  "crm-cards-sdk": "static-1.43672",
  "customer-data-properties-shared-msw-handlers": "static-1.9359",
  "customer-data-tracking": "static-1.6919",
  "hs-resources": "static-1.184",
  "pulse": "static-1.609",
  "calling-global-api": "static-1.64608",
  "calling-internal-common": "static-1.31331",
  "calling-lifecycle-internal": "static-1.65990",
  "calling-lifecycle-messages": "static-1.58284",
  "commerce-products-lib": "static-1.9670",
  "conditional-properties-service-client": "static-1.3820",
  "crm-links": "static-1.6324",
  "external-options-client-types": "static-1.4182",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4246",
  "meetings-icalendar-utils-lib": "static-1.661",
  "multi-currency-client-types": "static-1.3714",
  "object-builder-ui-client": "static-1.48837",
  "pipeline-validation-client-types": "static-1.3988",
  "smart-property-lib": "static-1.7230",
  "tiered-pricing": "static-1.1280",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11019",
  "crm-pipelines-api-client-types": "static-1.4162",
  "fdsr-migration-layer": "static-1.33",
  "react-dnd-compat": "static-1.4644",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.975",
  "growth-data-modal": "static-1.5472",
  "growth-onboarding-confetti": "static-1.3096",
  "growth-onboarding-next-action-utils": "static-1.2001",
  "onboarding-tours-utils": "static-1.733",
  "ui-shepherd-tracker": "static-1.7581",
  "academy-service-client": "static-1.3711",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39199",
  "FileManagerLib": "static-1.39340",
  "video-embed": "static-1.35869",
  "ui-coaching-tips": "static-1.28640",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11377",
  "video-data-lib": "static-1.35035",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8501",
  "payment-link-components": "static-1.23620",
  "ui-addon-emoji-picker": "static-1.9917",
  "EmailSignatureEditor": "static-1.24434",
  "viral-links-lib": "static-1.7096",
  "data-token-picker": "static-1.16455",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.255",
  "timezone-utils": "static-2.5274",
  "seat-types-lib": "static-1.77",
  "getting-started-shared-tasks-store": "static-1.17646",
  "ui-addon-opt": "static-4.8393",
  "campaign-roi-lib": "static-1.9201",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7355",
  "customer-data-views-management": "static-1.25521",
  "framework-data-table": "static-2.11980",
  "marketing-platform-lib": "static-1.6887",
  "nudge-client-utils": "static-1.2639",
  "nudge-custom-ui-functions": "static-1.1075",
  "app-users-service-client": "static-1.5627",
  "app-users-service-types": "static-1.5035",
  "mini-checkout-client": "static-1.26876",
  "onboarding-utils": "static-1.5383",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28625",
  "edison-service-client-types": "static-1.418",
  "crm_data": "static-4.92050",
  "customer-data-sidebar": "static-2.46098",
  "enrichment-properties-lib": "static-1.16348",
  "ui-addon-draggable-compat": "static-2.4286",
  "commerce-billing-lib": "static-1.19168",
  "commerce-shared-components-lib": "static-1.18618",
  "commerce-tools-ui-lib": "static-1.10453",
  "crm-fe-perf": "static-1.22933",
  "bend-plugin-pulse": "static-1.112",
  "event-emitter": "static-1.977",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31338",
  "shared-worker-versioning": "static-1.11066",
  "calling-usage-tracker": "static-1.6570",
  "voice-sms-access-library": "static-1.1099",
  "commerce-permissions": "static-1.800",
  "products-iframe-lib": "static-1.8015",
  "products-ui-components-shared-msw-handlers": "static-1.10414",
  "data-agent-kit": "static-1.239",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10115",
  "policy-lib": "static-1.6806",
  "react-tinymce": "static-1.55323",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10178",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54449",
  "tinymce-plugins": "static-1.57563",
  "tinymce-themes": "static-1.56419",
  "onboarding-data-sync-lib": "static-1.2001",
  "growth-onboarding-next-action-components": "static-1.2029",
  "user-context-client": "static-1.4641",
  "audio-components": "static-1.5958",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36851",
  "urlinator": "static-1.4566",
  "video-components": "static-1.13380",
  "outpost": "static-1.4207",
  "growth-onboarding-feedback-components": "static-1.6609",
  "content-media-composition-data-lib": "static-1.12424",
  "content-media-compositions": "static-2.16431",
  "media-bridge-lib": "static-1.18974",
  "commerce-tours-lib": "static-1.6155",
  "growth-onboarding-reliability": "static-1.5111",
  "sales-checkout-service-client": "static-1.3671",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21724",
  "sales-email-signature-service-client": "static-1.3873",
  "ts-utils-lib": "static-1.201",
  "breeze-engine-lib": "static-1.741",
  "crm-export-dialog": "static-1.6318",
  "crm-index-associations-lib": "static-1.6469",
  "crm-view-components": "static-1.353",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2396",
  "nudge-renderer-utils": "static-1.2715",
  "whisper-core-api": "static-1.6703",
  "InboxConnectUtils": "static-4.14894",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5617",
  "settings-content-modals": "static-1.46166",
  "crm_universal": "static-1.22055",
  "customer-data-email": "static-1.18082",
  "card-payment-highlight-lib": "static-1.37259",
  "card-subscription-highlight-lib": "static-1.39625",
  "commerce-contract-lib": "static-1.12191",
  "invoices-highlight-card-lib": "static-1.54817",
  "orders-highlight-card-lib": "static-1.21549",
  "products-highlight-card-lib": "static-1.17953",
  "quotes-highlight-card-lib": "static-1.72142",
  "crm-source-interpretation-lib": "static-1.5372",
  "utility-belt": "static-1.2563",
  "payments-enrollment-embed-lib": "static-1.22981",
  "stripe-embedded-components": "static-1.7554",
  "customer-data-rte": "static-1.33073",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5785",
  "payments-post-enroll-local-storage-lib": "static-1.5138",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38232",
  "trials-service-types": "static-1.3933",
  "calling-orchestration-schema": "static-1.35876",
  "sales-views-client-types": "static-1.4288",
  "hub-http-contrib": "static-1.3071",
  "interframe": "static-3.4789",
  "tinymce-data": "static-1.40534",
  "ui-addon-sales-email": "static-1.5240",
  "layout-dnd-components": "static-1.12498",
  "layout-dnd-utils": "static-1.11473",
  "ui-brand-identity-lib": "static-1.15405",
  "NamespacedHubStyle": "static-2.9081",
  "meetings-connect-utils-lib": "static-1.7634",
  "social-insights-client-types": "static-1.22190",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4174",
  "checkout-sdk": "static-3.23719",
  "checkout-service-types": "static-1.3844",
  "company-details-components": "static-1.6224",
  "payment-method-components": "static-1.6929",
  "pricing-pages-ui-components": "static-1.14149",
  "quote-checkout-service-types": "static-1.3497",
  "upgrade-catalog-service-types": "static-1.3549",
  "access-control-lib": "static-1.10465",
  "EmailComponents": "static-1.54831",
  "EmailData": "static-1.53508",
  "redux-less": "static-2.9513",
  "sequences-lib": "static-1.8090",
  "ui-gdpr-components": "static-1.10379",
  "products-ui-components": "static-1.40188",
  "accounting-integrations-ui-components": "static-1.7108",
  "invoices-ui-lib": "static-1.54833",
  "commerce-products-api": "static-1.2339",
  "invoices-iframe-lib": "static-1.56891",
  "quotes-modal-lib": "static-1.102820",
  "quotes-ui-lib": "static-1.80863",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28346",
  "ContentData": "static-1.68524",
  "layout-data-lib": "static-1.9798",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3968",
  "billing-payments-client-types": "static-1.4019",
  "react-performance-metrics-lib": "static-1.585",
  "account-and-billing-fintech-outages": "static-3.18627",
  "pricing-pages-api": "static-1.14014",
  "ContentComponents": "static-2.71405",
  "marketing-contacts-lib": "static-1.10141",
  "marketing-email-service-types": "static-1.1924",
  "messaging-editing-lib": "static-1.46357",
  "messaging-usage-based-billing-components-lib": "static-1.1219",
  "automation-ui-source-apps": "static-1.18972",
  "automation-ui-types": "static-1.19890",
  "messaging-types-lib": "static-1.46094",
  "onboarding-settings-client": "static-1.4534",
  "sequences-client-types-lib": "static-1.7947",
  "commerce-tax-lib": "static-1.556",
  "price-books-api": "static-1.877",
  "price-books-components": "static-1.935",
  "property-description-translator": "static-1.3872",
  "ramp-editor": "static-1.214",
  "commerce-analytics-service-client": "static-1.3659",
  "totals-ui-components": "static-1.23681",
  "SalesContentIndexUI": "static-3.9293",
  "advanced-menus-core": "static-1.15172",
  "advanced-menus-lib": "static-1.12110",
  "ui-memberships-settings-lib": "static-1.34125",
  "segments-query-core": "static-1.1448",
  "demographics-service-types": "static-1.1682",
  "eligibility-engine-service-types": "static-1.3214",
  "automation-ui-ubb": "static-1.5806",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7368",
  "data-token-views": "static-1.16436",
  "forms-utils-lib": "static-1.12636",
  "payments-embed-points-lib": "static-1.13095",
  "simple-menus-core": "static-1.15171",
  "simple-menus-lib": "static-1.16688",
  "videoconference-integration-components": "static-1.6862",
  "marketing-contacts-client": "static-1.7546",
  "automation-applications-service-types": "static-1.3538",
  "automation-platform-service-types": "static-1.2598",
  "ContentEditorUI": "static-2.77191",
  "short-messages-app-service-client": "static-1.3998",
  "web-interactives-components": "static-1.13807",
  "web-interactives-data": "static-1.13808",
  "messaging-shared-utils-lib": "static-1.668",
  "messaging-user-info-utils-lib": "static-1.838",
  "email-portal-health-service-types": "static-1.1007",
  "line-items-api": "static-1.739",
  "commerce-totals-service-types": "static-1.3842",
  "FireAlarmUi": "static-1.4535",
  "sales-templates-service-types-lib": "static-1.4193",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21826",
  "automation-ui-usage-tracking": "static-1.21289",
  "data-studio-ubb": "static-1.2808",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27100",
  "collaboration-sidebar": "static-1.57914",
  "content-management-data-lib": "static-1.5426",
  "copilot-plugins": "static-1.11179",
  "cta-picker": "static-1.36482",
  "customer-agent-discovery-components-lib": "static-1.3163",
  "editor-components": "static-1.13269",
  "editor-iframe-lib": "static-1.8443",
  "error-messaging-js": "static-1.5222",
  "FormsCommonComponents": "static-1.85931",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10674",
  "SharedLegalStrings": "static-1.1776",
  "smart-content-core": "static-1.42524",
  "smart-content-lib": "static-1.43177",
  "social-composer-lib": "static-1.59279",
  "structured-content-lib": "static-1.25270",
  "theme-previewer-lib": "static-1.53316",
  "tinymce-copilot": "static-1.16517",
  "xray-recommendation-lib": "static-1.7948",
  "automation-ui-routing": "static-1.21247",
  "sql-reporting-client-types": "static-1.5655",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42261",
  "campaigns-utils-lib": "static-1.3211",
  "reporting-enablement": "static-1.23021",
  "chatspot-widget-iframe": "static-1.21406",
  "collaboration-sidebar-common": "static-1.2711",
  "forms-ai-lib": "static-1.4361",
  "codemirror-dlb": "static-1.58750",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6461",
  "report-customization-components": "static-1.13254",
  "data-quality-ui-library": "static-1.13119",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.399",
  "reporting-insights-lib": "static-1.1831"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12357",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.469",
  "data-fetching-client": "/data-fetching-client/static-1.9696",
  "foundations-components": "/foundations-components/static-1.7991",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1016",
  "foundations-theming": "/foundations-theming/static-1.4449",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8043",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10032",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11501",
  "I18n": "/I18n/static-7-hdineen_hubspot-i18n-react-compiler.2",
  "jasmine-runner": "/jasmine-runner/static-1.6493",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12418",
  "quartz": "/quartz/static-1.7067",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16701",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2888",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9608",
  "settings-ui-lib": "/settings-ui-lib/static-1.12549",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7190",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11178",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9571",
  "unified-auth": "/unified-auth/static-1.526",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.808",
  "usage-tracker": "/usage-tracker/static-1.7377",
  "usage-tracker-core": "/usage-tracker-core/static-1.7227",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8120",
  "hub-http": "/hub-http/static-1.6251",
  "integrations-lib": "/integrations-lib/static-1.16249",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19841",
  "property-management-iframe": "/property-management-iframe/static-1.13254",
  "quartz-config": "/quartz-config/static-1.845",
  "quartz-core": "/quartz-core/static-1.6286",
  "quartz-routing": "/quartz-routing/static-1.497",
  "quick-fetch": "/quick-fetch/static-1.3939",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4681",
  "ts-schema": "/ts-schema/static-1.4103",
  "ui-universal-auth": "/ui-universal-auth/static-1.9012",
  "UIComponents": "/UIComponents/static-3.8447",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3421",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3344",
  "quartz-webpack": "/quartz-webpack/static-1.3291",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.145",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4260",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4897",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2165",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9453",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5367",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.2030",
  "ui-fonts": "/ui-fonts/static-1.763",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2932",
  "foundations-theming-base": "/foundations-theming-base/static-1.3434",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3154",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4356",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9042",
  "ai-rendering-library": "/ai-rendering-library/static-1.10267",
  "chirp-fetch": "/chirp-fetch/static-1.1917",
  "connections-embed-lib": "/connections-embed-lib/static-1.1040",
  "copilot-toolkit": "/copilot-toolkit/static-1.11206",
  "feedback-loader": "/feedback-loader/static-1.29348",
  "laboratory-lib": "/laboratory-lib/static-3.7185",
  "marketplace-embed": "/marketplace-embed/static-1.22167",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9736",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19796",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14011",
  "sanitize-text": "/sanitize-text/static-1.8172",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8732",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5791",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5063",
  "wootric-nps": "/wootric-nps/static-1.7003",
  "quartz-head": "/quartz-head/static-1.732",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4681",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4183",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2504",
  "reporting-data": "/reporting-data/static-1.67675",
  "cssUtils": "/cssUtils/static-1.798",
  "flux-actions": "/flux-actions/static-1.341",
  "HubStyle": "/HubStyle/static-2.11808",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10237",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10395",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7367",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18373",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4544",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5474",
  "quartz-i18n": "/quartz-i18n/static-1.742",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.322",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.446",
  "slack-ui-library": "/slack-ui-library/static-1.10421",
  "fsm": "/fsm/static-1.3761",
  "customer-data-objects": "/customer-data-objects/static-1.7702",
  "property-translator": "/property-translator/static-1.5428",
  "hs-locale-management": "/hs-locale-management/static-1.103",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7956",
  "hs-promise-utils": "/hs-promise-utils/static-1.5620",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4908",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13664",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5631",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7811",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4505",
  "superstore": "/superstore/static-1.4790",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10200",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7929",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4674",
  "immutable-less": "/immutable-less/static-1.4682",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17248",
  "nav-meta": "/nav-meta/static-1.29750",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10277",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18039",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3869",
  "property-management-common": "/property-management-common/static-1.5542",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9090",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.742",
  "quartz-test": "/quartz-test/static-1.742",
  "quartz-tracking": "/quartz-tracking/static-1.446",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.91",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21415",
  "ContentUtils": "/ContentUtils/static-1.68449",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13058",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.81",
  "avatar-components": "/avatar-components/static-1.2527",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39900",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13195",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14439",
  "ExportDialog": "/ExportDialog/static-6.10413",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41385",
  "reporting-snowflake": "/reporting-snowflake/static-1.56293",
  "reporting-ui-components": "/reporting-ui-components/static-2.64946",
  "reporting-visualizations": "/reporting-visualizations/static-1.59751",
  "ui-addon-teams": "/ui-addon-teams/static-1.21596",
  "magpie-lib": "/magpie-lib/static-1.5571",
  "navigation-components": "/navigation-components/static-1.18113",
  "magpie-types": "/magpie-types/static-1.5031",
  "simple-logging-lib": "/simple-logging-lib/static-1.3080",
  "ai-studio-lib": "/ai-studio-lib/static-1.11700",
  "app-governance-lib": "/app-governance-lib/static-1.1624",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10540",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8029",
  "ui-product-approvals": "/ui-product-approvals/static-1.28223",
  "ui-tool-access": "/ui-tool-access/static-1.10176",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9043",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5794",
  "usage-tracker-public": "/usage-tracker-public/static-1.7188",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3609",
  "persist-promise": "/persist-promise/static-1.3728",
  "reference-resolvers": "/reference-resolvers/static-1.8200",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3953",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.367",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3042",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2861",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5102",
  "purchase-motions-components": "/purchase-motions-components/static-1.5970",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1571",
  "crm-component-utils": "/crm-component-utils/static-1.39154",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5914",
  "customer-data-properties": "/customer-data-properties/static-1.51668",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6914",
  "property-value-citations": "/property-value-citations/static-1.2282",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8124",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9085",
  "navigation-messaging": "/navigation-messaging/static-1.7440",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10030",
  "cms-field-types": "/cms-field-types/static-1.4841",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9855",
  "events-data-lib": "/events-data-lib/static-1.254",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7277",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22335",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4748",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4028",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6819",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1009",
  "onboarding-tours": "/onboarding-tours/static-1.16667",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13764",
  "academy-common-lib": "/academy-common-lib/static-1.13899",
  "content-assistance-lib": "/content-assistance-lib/static-1.7795",
  "dashboard-lib": "/dashboard-lib/static-1.81644",
  "file-manager-components": "/file-manager-components/static-1.23700",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18528",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18311",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18303",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19881",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8731",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4792",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11075",
  "user-context": "/user-context/static-1.5134",
  "growth-payments-core": "/growth-payments-core/static-1.25460",
  "reporting-plugins": "/reporting-plugins/static-1.10371",
  "reporting-reports": "/reporting-reports/static-1.67353",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.752",
  "nest": "/nest/static-1.259",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10655",
  "framework-listing-lib": "/framework-listing-lib/static-2.28788",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30783",
  "apps-service-types": "/apps-service-types/static-1.3909",
  "oauth-service-types": "/oauth-service-types/static-1.4280",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.118",
  "onboarding-scopes": "/onboarding-scopes/static-1.6490",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4881",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7694",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14973",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9345",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5973",
  "signup-constants": "/signup-constants/static-1.18897",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8081",
  "card-properties-lib": "/card-properties-lib/static-1.44275",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37202",
  "crm-actions": "/crm-actions/static-1.6356",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43672",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9359",
  "customer-data-tracking": "/customer-data-tracking/static-1.6919",
  "hs-resources": "/hs-resources/static-1.184",
  "pulse": "/pulse/static-1.609",
  "calling-global-api": "/calling-global-api/static-1.64608",
  "calling-internal-common": "/calling-internal-common/static-1.31331",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65990",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58284",
  "commerce-products-lib": "/commerce-products-lib/static-1.9670",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3820",
  "crm-links": "/crm-links/static-1.6324",
  "external-options-client-types": "/external-options-client-types/static-1.4182",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4246",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.661",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3714",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48837",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3988",
  "smart-property-lib": "/smart-property-lib/static-1.7230",
  "tiered-pricing": "/tiered-pricing/static-1.1280",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11019",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4162",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.33",
  "react-dnd-compat": "/react-dnd-compat/static-1.4644",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.975",
  "growth-data-modal": "/growth-data-modal/static-1.5472",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3096",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2001",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.733",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7581",
  "academy-service-client": "/academy-service-client/static-1.3711",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39199",
  "FileManagerLib": "/FileManagerLib/static-1.39340",
  "video-embed": "/video-embed/static-1.35869",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28640",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11377",
  "video-data-lib": "/video-data-lib/static-1.35035",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8501",
  "payment-link-components": "/payment-link-components/static-1.23620",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9917",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24434",
  "viral-links-lib": "/viral-links-lib/static-1.7096",
  "data-token-picker": "/data-token-picker/static-1.16455",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.255",
  "timezone-utils": "/timezone-utils/static-2.5274",
  "seat-types-lib": "/seat-types-lib/static-1.77",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17646",
  "ui-addon-opt": "/ui-addon-opt/static-4.8393",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9201",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7355",
  "customer-data-views-management": "/customer-data-views-management/static-1.25521",
  "framework-data-table": "/framework-data-table/static-2.11980",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6887",
  "nudge-client-utils": "/nudge-client-utils/static-1.2639",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1075",
  "app-users-service-client": "/app-users-service-client/static-1.5627",
  "app-users-service-types": "/app-users-service-types/static-1.5035",
  "mini-checkout-client": "/mini-checkout-client/static-1.26876",
  "onboarding-utils": "/onboarding-utils/static-1.5383",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28625",
  "edison-service-client-types": "/edison-service-client-types/static-1.418",
  "crm_data": "/crm_data/static-4.92050",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46098",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16348",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4286",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19168",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18618",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10453",
  "crm-fe-perf": "/crm-fe-perf/static-1.22933",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.112",
  "event-emitter": "/event-emitter/static-1.977",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31338",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11066",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6570",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1099",
  "commerce-permissions": "/commerce-permissions/static-1.800",
  "products-iframe-lib": "/products-iframe-lib/static-1.8015",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10414",
  "data-agent-kit": "/data-agent-kit/static-1.239",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10115",
  "policy-lib": "/policy-lib/static-1.6806",
  "react-tinymce": "/react-tinymce/static-1.55323",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10178",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54449",
  "tinymce-plugins": "/tinymce-plugins/static-1.57563",
  "tinymce-themes": "/tinymce-themes/static-1.56419",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2001",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2029",
  "user-context-client": "/user-context-client/static-1.4641",
  "audio-components": "/audio-components/static-1.5958",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36851",
  "urlinator": "/urlinator/static-1.4566",
  "video-components": "/video-components/static-1.13380",
  "outpost": "/outpost/static-1.4207",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6609",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12424",
  "content-media-compositions": "/content-media-compositions/static-2.16431",
  "media-bridge-lib": "/media-bridge-lib/static-1.18974",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6155",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5111",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3671",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21724",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3873",
  "ts-utils-lib": "/ts-utils-lib/static-1.201",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.741",
  "crm-export-dialog": "/crm-export-dialog/static-1.6318",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6469",
  "crm-view-components": "/crm-view-components/static-1.353",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2396",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2715",
  "whisper-core-api": "/whisper-core-api/static-1.6703",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14894",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5617",
  "settings-content-modals": "/settings-content-modals/static-1.46166",
  "crm_universal": "/crm_universal/static-1.22055",
  "customer-data-email": "/customer-data-email/static-1.18082",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37259",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39625",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12191",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54817",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21549",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17953",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72142",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5372",
  "utility-belt": "/utility-belt/static-1.2563",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22981",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7554",
  "customer-data-rte": "/customer-data-rte/static-1.33073",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5785",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5138",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38232",
  "trials-service-types": "/trials-service-types/static-1.3933",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35876",
  "sales-views-client-types": "/sales-views-client-types/static-1.4288",
  "hub-http-contrib": "/hub-http-contrib/static-1.3071",
  "interframe": "/interframe/static-3.4789",
  "tinymce-data": "/tinymce-data/static-1.40534",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5240",
  "layout-dnd-components": "/layout-dnd-components/static-1.12498",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11473",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15405",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9081",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7634",
  "social-insights-client-types": "/social-insights-client-types/static-1.22190",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4174",
  "checkout-sdk": "/checkout-sdk/static-3.23719",
  "checkout-service-types": "/checkout-service-types/static-1.3844",
  "company-details-components": "/company-details-components/static-1.6224",
  "payment-method-components": "/payment-method-components/static-1.6929",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14149",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3497",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3549",
  "access-control-lib": "/access-control-lib/static-1.10465",
  "EmailComponents": "/EmailComponents/static-1.54831",
  "EmailData": "/EmailData/static-1.53508",
  "redux-less": "/redux-less/static-2.9513",
  "sequences-lib": "/sequences-lib/static-1.8090",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10379",
  "products-ui-components": "/products-ui-components/static-1.40188",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7108",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54833",
  "commerce-products-api": "/commerce-products-api/static-1.2339",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56891",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102820",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80863",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28346",
  "ContentData": "/ContentData/static-1.68524",
  "layout-data-lib": "/layout-data-lib/static-1.9798",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3968",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4019",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.585",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18627",
  "pricing-pages-api": "/pricing-pages-api/static-1.14014",
  "ContentComponents": "/ContentComponents/static-2.71405",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10141",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1924",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46357",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1219",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18972",
  "automation-ui-types": "/automation-ui-types/static-1.19890",
  "messaging-types-lib": "/messaging-types-lib/static-1.46094",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4534",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7947",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.556",
  "price-books-api": "/price-books-api/static-1.877",
  "price-books-components": "/price-books-components/static-1.935",
  "property-description-translator": "/property-description-translator/static-1.3872",
  "ramp-editor": "/ramp-editor/static-1.214",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3659",
  "totals-ui-components": "/totals-ui-components/static-1.23681",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9293",
  "advanced-menus-core": "/advanced-menus-core/static-1.15172",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12110",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34125",
  "segments-query-core": "/segments-query-core/static-1.1448",
  "demographics-service-types": "/demographics-service-types/static-1.1682",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3214",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5806",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7368",
  "data-token-views": "/data-token-views/static-1.16436",
  "forms-utils-lib": "/forms-utils-lib/static-1.12636",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13095",
  "simple-menus-core": "/simple-menus-core/static-1.15171",
  "simple-menus-lib": "/simple-menus-lib/static-1.16688",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6862",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7546",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3538",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2598",
  "ContentEditorUI": "/ContentEditorUI/static-2.77191",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3998",
  "web-interactives-components": "/web-interactives-components/static-1.13807",
  "web-interactives-data": "/web-interactives-data/static-1.13808",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.668",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.838",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1007",
  "line-items-api": "/line-items-api/static-1.739",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3842",
  "FireAlarmUi": "/FireAlarmUi/static-1.4535",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4193",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21826",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21289",
  "data-studio-ubb": "/data-studio-ubb/static-1.2808",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27100",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57914",
  "content-management-data-lib": "/content-management-data-lib/static-1.5426",
  "copilot-plugins": "/copilot-plugins/static-1.11179",
  "cta-picker": "/cta-picker/static-1.36482",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3163",
  "editor-components": "/editor-components/static-1.13269",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8443",
  "error-messaging-js": "/error-messaging-js/static-1.5222",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85931",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10674",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1776",
  "smart-content-core": "/smart-content-core/static-1.42524",
  "smart-content-lib": "/smart-content-lib/static-1.43177",
  "social-composer-lib": "/social-composer-lib/static-1.59279",
  "structured-content-lib": "/structured-content-lib/static-1.25270",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53316",
  "tinymce-copilot": "/tinymce-copilot/static-1.16517",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7948",
  "automation-ui-routing": "/automation-ui-routing/static-1.21247",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5655",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42261",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3211",
  "reporting-enablement": "/reporting-enablement/static-1.23021",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21406",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2711",
  "forms-ai-lib": "/forms-ai-lib/static-1.4361",
  "codemirror-dlb": "/codemirror-dlb/static-1.58750",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6461",
  "report-customization-components": "/report-customization-components/static-1.13254",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13119",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.399",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1831"
}
};
